import { JSX, ReactNode } from "react";
import { BaseComponent } from "../../Core/BaseComponent/BaseComponent";
import "./Styles.scss";

export class MenuItem extends BaseComponent<IMenuItemProps, IMenuItemState>
{
    private handleClick(): void
    {
        if (this.props.disabled)
        {
            return;
        }
        this.props.onClick();
    }

    public render(): JSX.Element
    {
        const cssClasses: string[] = [];
        cssClasses.push('context-menu__item');
        cssClasses.push(this.props.className);
        cssClasses.push(this.props.disabled ? 'context-menu__item--disabled' : '');

        return (
            <li
                className={cssClasses.filter(i => !!i).join(' ')}
                onClick={() => this.handleClick()}
            >
                {this.props.children}
            </li >
        );
    }
}

export interface IMenuItemProps
{
    disabled?: boolean;
    onClick: () => void;
    children: ReactNode;
    className: string;
}

export interface IMenuItemState { }
